
import { Component, computed, signal, ChangeDetectionStrategy, input } from '@angular/core';


@Component({
  selector: 'lib-icon',
  imports: [],
  templateUrl: './icon.component.html',
  styleUrl: './icon.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IconComponent {
  icon = input.required<string>()

  notificationIcon = signal<string>('notifications')
  closeIcon = signal<string>('close')
  iconComputed = computed(() => this.icon())
}
